import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const CircleFilledExclamationIcon = _ref => {
  let {
      size = "16",
      color = "white"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M12.5 6C12.5 9.31371 9.81371 12 6.5 12C3.18629 12 0.5 9.31371 0.5 6C0.5 2.68629 3.18629 0 6.5 0C9.81371 0 12.5 2.68629 12.5 6ZM6.5 3C6.09844 3 5.78467 3.34671 5.82463 3.74628L6.08769 6.37686C6.10887 6.58869 6.28712 6.75 6.5 6.75C6.71288 6.75 6.89113 6.58869 6.91231 6.37686L7.17537 3.74628C7.21533 3.34671 6.90156 3 6.5 3ZM6.50116 7.5C6.08694 7.5 5.75116 7.83579 5.75116 8.25C5.75116 8.66421 6.08694 9 6.50116 9C6.91537 9 7.25116 8.66421 7.25116 8.25C7.25116 7.83579 6.91537 7.5 6.50116 7.5Z",
    fill: color
  }));
};
export default CircleFilledExclamationIcon;